// Flip to true to bring the Event Schedule section (and its nav link) back.
//
// The page's colour bands (the gradient on <html> in src/index.css, mirrored in
// gradients.page in src/theme.ts) are positioned as percentages of the whole page's height, so
// toggling this — or any other change that meaningfully changes the page's total height —
// means re-measuring and updating those percentages, or the colours land on the wrong
// sections (e.g. blue arriving well past the hero instead of at its middle). Current tuning
// (schedule shown) is measured against the page as it stands now:
//   #2B2F3E 1.7%, #3689DD 5.5%, #3689DD 21%, #7B3196 33.5%, #7B3196 100%
// It only needs to land correctly through the end of the Event Schedule section — every
// section from FAQ on paints its own opaque background now, so nothing below that ever shows
// this gradient.
export const SHOW_EVENT_SCHEDULE = true;
